import React, { useState } from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ConsumedResourceDocument } from '../../models/table-models';
import { TableInnerProps } from '../../models/table-models';
import { consumedResourcesItemsTableHeaders, consumedResourcesTableHeaders } from '../../utils/Enums/TableHeaders';
import { transformDateToString } from '../../utils/helper-functions';
import { PaginationComponent } from '../../components/Pagination';
import { NoDataComponent } from '../../components/NoDataComponent';
import { checkered } from '../../styles/selectStyles';

export const ConsumedResourcesTable = ({
    getEntities,
    pagination,
}: TableInnerProps<ConsumedResourceDocument>) => {
    const { t } = useTranslation('translation', { keyPrefix: 'table' });
    const commonTranslation = useTranslation('translation', { keyPrefix: 'common' });
    const { items, pager } = getEntities();
    const [expandedRows, setExpandedRows] = useState<number[]>([]);

    const toggleRow = (index: number) => {
        setExpandedRows((rows) =>
            rows.includes(index) ? rows.filter((rowIndex) => rowIndex !== index) : [...rows, index],
        );
    };

    return items && items.length > 0 ? (
        <>
            <Table responsive className='w-100'>
                <thead className='background-dark color-main'>
                    <tr>
                        {consumedResourcesTableHeaders.map((header) => (
                            <th key={header} className='single-line-text table-header text-center fw-bold'>
                                {t(header)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className='accordionTableRow cursor-pointer'>
                    {items.map((item, index) => (
                        <React.Fragment key={`${item.documentNumber}-${index}`}>
                            <tr className={checkered(index)} onClick={() => toggleRow(index)}>
                                <td>{item.documentNumber}</td>
                                <td>{item.supplierName}</td>
                                <td>{item.createdAt ? transformDateToString(item.createdAt, 'dd/mm/yyyy HH:MM') : ''}</td>
                                <td>{item.totalQuantity}</td>
                                <td>{item.totalDeliveryPrice}</td>
                            </tr>
                            {expandedRows.includes(index) && (
                                <tr>
                                    <td colSpan={consumedResourcesTableHeaders.length} className='p-2'>
                                        <Table responsive size='sm' className='mb-0'>
                                            <thead className='background-dark color-main'>
                                                <tr>
                                                    {consumedResourcesItemsTableHeaders.map((header) => (
                                                        <th
                                                            key={header}
                                                            className='single-line-text table-header text-center fw-bold p-2'
                                                        >
                                                            {t(header)}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item.items.map((resourceItem, itemIndex) => (
                                                    <tr key={resourceItem.id ?? `${resourceItem.batchCode}-${itemIndex}`}>
                                                        <td>{resourceItem.description}</td>
                                                        <td>{resourceItem.passportName || resourceItem.passport}</td>
                                                        <td>{resourceItem.batchCode}</td>
                                                        <td>{resourceItem.deliveryPrice}</td>
                                                        <td>
                                                            {resourceItem.quantity}{' '}
                                                            {resourceItem.quantityUnit === 'ML' ? 'ml' : 'pcs'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </Table>
            <PaginationComponent
                recordsCount={pager.totalCount ?? items.length}
                pagination={{ ...pagination, pageSize: pager.itemsPerPage ?? pagination.pageSize }}
            />
        </>
    ) : (
        <NoDataComponent noDataText={commonTranslation.t('consumedResources')} />
    );
};
